import { getSrcs, imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import ArticleTags from '@stories/Components/Misc/ArticleTags/ArticleTags';
import * as React from 'react';
import S from './NewsArticleHeader.styles';
const NewsArticleHeader = (props) => {
    if (!props.title) {
        return null;
    }
    const imageSrc = props.image ? getSrcs(props.image, 1720, 680, 8, 855 / 638) : null;
    return (React.createElement(S.Container, { flush: "bottom", "data-type": props.type, background: props.variant, translations: props.translations },
        React.createElement(S.IntroBlock, null,
            React.createElement(ArticleTags, { id: props.id, tags: props.tags, readTime: props.readTime, type: props.type }),
            React.createElement(S.TitleBlock, null,
                props.title && React.createElement(S.Title, null, props.title),
                props.introduction && React.createElement(S.Introduction, null, props.introduction)),
            props.author && props.author.name && (React.createElement(S.AuthorBlock, null,
                props.author.image && props.author.image.src && (React.createElement(S.AuthorImageHolder, null,
                    React.createElement(S.AuthorImage, { src: imageUrl(props.author.image, { width: 104, height: 104 }), alt: props.author.name, loading: "eager" }))),
                React.createElement(S.AuthorName, null, props.author.name)))),
        imageSrc && props.image && (React.createElement(S.MediaHolder, null,
            React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, alt: props.image.altText ?? props.title, loading: "eager", sizes: `${until(Device.Tablet)} 100vw, ${until(Device.TabletLarge)} 83vw, ${until(Device.Desktop)} 67vw,  ${until(Device.ActualDesktop)} 50vw, 854px` })))));
};
export default NewsArticleHeader;
